require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./container"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./container"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./container")) : factory(root["./utils"], root["./container"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__18__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[24],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__18__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 261:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(262);


/***/ }),

/***/ 262:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

exports.__esModule = true;

var _FlexLayout = _interopRequireWildcard(__webpack_require__(263));

exports["default"] = _FlexLayout["default"];
exports.FlexLayout = _FlexLayout["default"];
exports.FlexItem = _FlexLayout.FlexItem;

/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.FlexItem = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _container = _interopRequireDefault(__webpack_require__(18));

var _utils = __webpack_require__(4);

__webpack_require__(264);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var sanitize = _utils.propsUtils.sanitize;

var FlexLayout = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(FlexLayout, _Component);

  function FlexLayout() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = FlexLayout.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        style = _this$props.style,
        fullHeight = _this$props.fullHeight,
        direction = _this$props.direction,
        alignItems = _this$props.alignItems,
        children = _this$props.children,
        wrap = _this$props.wrap,
        justifyContent = _this$props.justifyContent,
        inline = _this$props.inline,
        width = _this$props.width,
        height = _this$props.height,
        minHeight = _this$props.minHeight,
        minWidth = _this$props.minWidth,
        maxHeight = _this$props.maxHeight,
        maxWidth = _this$props.maxWidth,
        outer = _this$props.outer,
        outerClassName = _this$props.outerClassName,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["className", "style", "fullHeight", "direction", "alignItems", "children", "wrap", "justifyContent", "inline", "width", "height", "minHeight", "minWidth", "maxHeight", "maxWidth", "outer", "outerClassName"]);
    var classNames = (0, _utils.classnames)('ba-common-flexLayout', {
      fullHeight: fullHeight
    });
    var styles = (0, _extends2["default"])({}, style, {
      flexDirection: direction,
      flexWrap: wrap,
      alignItems: alignItems,
      justifyContent: justifyContent,
      width: width,
      height: height,
      minHeight: minHeight,
      minWidth: minWidth,
      maxHeight: maxHeight,
      maxWidth: maxWidth
    });
    var inner = fullHeight ? _react["default"].Children.map(children, function (child) {
      return child && child.type && child.type.__FlexItem__ // eslint-disable-line no-underscore-dangle
      ? _react["default"].cloneElement(child, {
        rowLayout: direction === 'row' || direction === 'row-reverse',
        fullHeightLayout: true
      }) : child;
    }) : children;
    var display = inline ? 'inline-flex' : 'flex';

    if ((direction == null || direction === 'row' || direction === 'row-reverse') && alignItems != null) {
      // The following is specifically to fix IE11 layout issues with align items inside a row flex layout.
      // IE 11 does not correctly align items unless the flex layout has a fixed height.
      // To get around this we create a column layout and align the items vertically inside it.
      var outerStyle = {
        display: display,
        maxWidth: '100%',
        flexDirection: 'column',
        justifyContent: alignItems
      };

      if (inline) {
        outerStyle.verticalAlign = 'middle';
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        style: outerStyle,
        className: outerClassName
      }, outer, /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, sanitize(others, FlexLayout), {
        className: classNames + " " + className,
        style: (0, _extends2["default"])({}, styles)
      }), inner));
    }

    styles.display = display;

    if (inline) {
      styles.verticalAlign = 'middle';
    }

    return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, sanitize(others, FlexLayout), {
      className: classNames + " " + className,
      style: styles
    }), inner);
  };

  return FlexLayout;
}(_react.Component);

exports["default"] = FlexLayout;
(0, _defineProperty2["default"])(FlexLayout, "__FlexLayout__", true);
(0, _defineProperty2["default"])(FlexLayout, "propTypes", {
  className: _propTypes["default"].string,
  outerClassName: _propTypes["default"].string,
  children: _propTypes["default"].node,
  fullHeight: _propTypes["default"].bool,
  style: _propTypes["default"].object,
  direction: _propTypes["default"].oneOf(['column', 'row', 'row-reverse', 'column-reverse']),
  alignItems: _propTypes["default"].oneOf(['stretch', 'center', 'flex-start', 'flex-end', 'baseline']),
  wrap: _propTypes["default"].oneOf(['nowrap', 'wrap', 'wrap-reverse']),
  justifyContent: _propTypes["default"].oneOf(['flex-start', 'flex-end', 'center', 'space-between', 'space-around']),
  inline: _propTypes["default"].bool,
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  minHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  maxWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  maxHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  outer: _propTypes["default"].element
});
(0, _defineProperty2["default"])(FlexLayout, "defaultProps", {
  className: '',
  maxWidth: '100%'
});

var FlexItem = /*#__PURE__*/function (_Component2) {
  (0, _inheritsLoose2["default"])(FlexItem, _Component2);

  function FlexItem() {
    return _Component2.apply(this, arguments) || this;
  }

  var _proto2 = FlexItem.prototype;

  _proto2.render = function render() {
    var _this$props2 = this.props,
        className = _this$props2.className,
        style = _this$props2.style,
        order = _this$props2.order,
        grow = _this$props2.grow,
        shrink = _this$props2.shrink,
        relative = _this$props2.relative,
        alignSelf = _this$props2.alignSelf,
        textAlign = _this$props2.textAlign,
        basis = _this$props2.basis,
        overflow = _this$props2.overflow,
        fullHeightLayout = _this$props2.fullHeightLayout,
        rowLayout = _this$props2.rowLayout,
        simpleContent = _this$props2.simpleContent,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props2, ["className", "style", "order", "grow", "shrink", "relative", "alignSelf", "textAlign", "basis", "overflow", "fullHeightLayout", "rowLayout", "simpleContent"]);
    var children = this.props.children;
    var classNames = (0, _utils.classnames)('ba-common-flexLayout-item');
    var flexGrow;

    if (grow === true) {
      flexGrow = 1;
    } else {
      flexGrow = grow > 0 ? grow : 0;
    }

    var flexShrink;

    if (shrink != null) {
      flexShrink = shrink ? 1 : 0;
    } else {
      flexShrink = flexGrow;
    }

    var flexBasis = basis || (grow ? 0 : null);
    var styles = (0, _extends2["default"])({}, style, {
      flexBasis: flexBasis,
      flexGrow: flexGrow,
      flexShrink: flexShrink,
      alignSelf: alignSelf,
      order: order
    });

    if (relative) {
      styles.position = 'relative';
    } // Work around ancient Safari bug https://bugs.webkit.org/show_bug.cgi?id=137730
    // If a nested child is a flex layout with fullHeight then we need to wrap it.
    // We also need to do this to allow a child components to use a height of 100% without causing
    // the flex layout to grow beyond its bounds.
    // And if a flex layout has direction row and any child flex item nests a flex layout with full height.
    // In this case the flex item should also have a width that's not dependent on the child content. There's several ways
    // to achieve this so we cannot assume to be able to check this case in code here.


    if (children != null && _react["default"].Children.count(children) === 1) {
      var child = _react["default"].Children.toArray(children).filter(function (c) {
        return c;
      })[0];

      if (child && (!simpleContent && grow && fullHeightLayout || rowLayout && child.type && child.type.__FlexLayout__ && child.props.fullHeight)) {
        // eslint-disable-line no-underscore-dangle
        styles.position = 'relative';
        children = /*#__PURE__*/_react["default"].createElement("div", {
          className: "ba-common-flexLayout__sw",
          style: {
            overflow: overflow
          }
        }, children);
      } else {
        styles.overflow = overflow;
      }
    } else {
      styles.overflow = overflow;
    }

    return /*#__PURE__*/_react["default"].createElement(_container["default"], (0, _extends2["default"])({}, sanitize(others, FlexItem), {
      className: classNames + " " + className,
      style: styles,
      textAlign: textAlign
    }), children);
  };

  return FlexItem;
}(_react.Component);

exports.FlexItem = FlexItem;
(0, _defineProperty2["default"])(FlexItem, "__FlexItem__", true);
(0, _defineProperty2["default"])(FlexItem, "propTypes", {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node,
  grow: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].number]),
  shrink: _propTypes["default"].bool,
  relative: _propTypes["default"].bool,
  textAlign: _propTypes["default"].oneOf(['left', 'right', 'center']),
  basis: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  overflow: _propTypes["default"].string,
  style: _propTypes["default"].object,
  fullHeightLayout: _propTypes["default"].bool,
  rowLayout: _propTypes["default"].bool,
  order: _propTypes["default"].number,
  alignSelf: _propTypes["default"].oneOf(['stretch', 'center', 'flex-start', 'flex-end', 'baseline']),
  // a means to opt out of the flex layout bug fix
  simpleContent: _propTypes["default"].bool
});
(0, _defineProperty2["default"])(FlexItem, "defaultProps", {
  className: ''
});

/***/ }),

/***/ 264:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(265);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-flexLayout{display:flex}.ba-common-flexLayout.is-fullHeight{height:100%}.ba-common-flexLayout__sw{position:absolute;top:0;left:0;right:0;bottom:0}.ba-common-flexLayout-item{min-width:0;min-height:0;max-width:100%}@media all and (-ms-high-contrast: none), (-ms-high-contrast: active){.ba-common-flexLayout-item{max-width:100%}}\n", ""]);

// exports


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[261,0]]]);
});